// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"76":"common","945":"dashboard"}[chunkId] + "." + {"76":"e35c24fa","945":"e83b987d"}[chunkId] + ".css";
};